import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarkerAlt } from '@fortawesome/pro-light-svg-icons'

import { Box, DashboardModule, SidebarModal, Text } from '@domain-group/suit-theme'

import { PriceListItemOptionValueModel } from '@models/types'

import TargetingListItem from '../TargetingListItem'

interface LocationTargetingProps {
  callbacks: {
    toggleGeoTargetingId: (id: number) => void,
  },
  loading: boolean,
  priceListItemOptionValues: PriceListItemOptionValueModel[],
  selectedPriceListItemOptionValues: number[],
}

const LocationTargeting = (props: LocationTargetingProps) => {
  const {
    callbacks: {
      toggleGeoTargetingId,
    },
    loading,
    priceListItemOptionValues,
    selectedPriceListItemOptionValues,
  } = props

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      loading={loading}
      title="Location Targeting"
    >
      {!loading && (
        <Box flexDirection="column" padding="large">
          <SidebarModal.NoticeBox>
            <Box>
              <FontAwesomeIcon icon={faMapMarkerAlt} style={{ marginBottom: 8, marginRight: 8 }} />

              <SidebarModal.NoticeBox.Title>Select Additional Locations</SidebarModal.NoticeBox.Title>
            </Box>

            <SidebarModal.NoticeBox.Paragraph boxProps={{ marginTop: 'none', marginBottom: 'medium' }}>
              If you would like your ad served outside of the close proximity to the property you can add additional targeting locations here
            </SidebarModal.NoticeBox.Paragraph>
          </SidebarModal.NoticeBox>

          <Text
            color="bodyFontLightColor"
            fontSize="xsmall"
            letterSpacing="0.5px"
            marginBottom="medium"
          >
            Location Targeting
          </Text>

          {priceListItemOptionValues.map((priceListItemOptionValue) => (
            <TargetingListItem
              callbacks={{
                selectTargeting: () => toggleGeoTargetingId(priceListItemOptionValue.id),
              }}
              isSelected={selectedPriceListItemOptionValues.includes(priceListItemOptionValue.id)}
              key={priceListItemOptionValue.id}
              priceListItemOptionValue={priceListItemOptionValue}
            />
          ))}
        </Box>
      )}
    </DashboardModule>
  )
}

export default LocationTargeting